module.exports = __webpack_public_path__ + "img/banner-bebe.22e64b8c.jpeg";